import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PosPersonReferenceModalComponent } from './pos-person-reference-modal.component';
import { PosPersonReferenceModalService } from 'src/app/@core/services/pos-person-reference-modal.service';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxMaskModule } from 'ngx-mask';
import { RequiredAsteriskModule } from 'src/app/@core/directives/required-asterisk/required-asterisk.module';



@NgModule({
  declarations: [PosPersonReferenceModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    ReactiveFormsModule,
    NgxMaskModule,
    NgSelectModule,
    RequiredAsteriskModule
  ],
  providers: [PosPersonReferenceModalService],
  exports: [PosPersonReferenceModalComponent]
})
export class PosPersonReferenceModalModule { }
